import CTAVideo from './CTAVideo.vue'

export default CTAVideo
